import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';
import Textarea from '#globalComponents/Forms/Textarea';
import Panel from '#globalComponents/Overlay/Panel';
import { CANCELLATION_REASONS, COMMENT_MAX_LENGTH } from '#settingsFeature/utils/cancellationFlow';

import OptionCard from '../components/OptionCard';

export default function ReasonStep({ reason, comment, onReasonChange, onCommentChange, onNext, onAbort, onClose }) {
	const commentLabel =
		reason === 'missing_features'
			? 'Welche Funktionen fehlen Ihnen? (optional)'
			: 'Möchten Sie uns mehr dazu sagen? (optional)';

	return (
		<>
			<Panel.Header onClose={onClose}>Schade, dass Sie gehen möchten</Panel.Header>

			<Panel.Body>
				<div className="space-y-5">
					<p className="text-sm text-text">
						Was ist der Hauptgrund für Ihre Kündigung? Ihre Antwort hilft uns, B2B Hero besser zu machen.
					</p>

					<fieldset>
						<legend className="block text-sm font-medium text-text mb-2">Grund *</legend>
						<div className="space-y-2">
							{CANCELLATION_REASONS.map((option) => (
								<OptionCard
									key={option.value}
									name="cancellationReason"
									value={option.value}
									checked={reason === option.value}
									onChange={onReasonChange}
									title={option.label}
								/>
							))}
						</div>
					</fieldset>

					<div>
						<label htmlFor="cancellationComment" className="block text-sm font-medium text-text mb-1.5">
							{commentLabel}
						</label>
						<Textarea
							id="cancellationComment"
							value={comment}
							onChange={(e) => onCommentChange(e.target.value)}
							maxLength={COMMENT_MAX_LENGTH}
							placeholder="z. B. welche Funktion fehlt oder was nicht funktioniert hat"
						/>
						<p className="mt-1 text-xs text-bgBase-800 text-right">
							{comment.length}/{COMMENT_MAX_LENGTH}
						</p>
					</div>
				</div>
			</Panel.Body>

			<Panel.Footer className="justify-end">
				<Button variant="outline" onClick={onAbort}>
					Abbrechen
				</Button>
				<Button variant="solid" onClick={onNext} disabled={!reason}>
					Weiter zur Kündigung
				</Button>
			</Panel.Footer>
		</>
	);
}

ReasonStep.propTypes = {
	reason: PropTypes.string,
	comment: PropTypes.string.isRequired,
	onReasonChange: PropTypes.func.isRequired,
	onCommentChange: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
	onAbort: PropTypes.func.isRequired,
	onClose: PropTypes.func,
};
